import PageHeading from '@shared/ui/PageHeading';
import { Accordion } from 'rsuite';
import { EmailBtn, TelegramBtn } from '@widgets/buttons';
import { useTranslation } from 'react-i18next';

export default function SupportPage() {
  const { t } = useTranslation();
  return (
    <section className="main-section support-page">
      <PageHeading title={t('Support')}>
        <TelegramBtn changeOnMobile />
        <EmailBtn changeOnMobile />
      </PageHeading>
      <div className="block-pd-x">
        <Accordion>
          <Accordion.Panel
            header="What is the difference between a checking and savings account?"
            defaultExpanded
          >
            <p>
              Online banking lets you manage your bank account via the internet,
              offering services like transfers, bill payments, and balance
              checks.
            </p>
          </Accordion.Panel>
        </Accordion>
      </div>
    </section>
  );
}
